var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 605.713,
    height: 256.967,
    viewBox: "0 0 605.713 256.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8739",
    "data-name": "Group 8739",
    transform: "translate(-2978.64 -4279.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9_404_error",
    "data-name": "9 404 error",
    transform: "translate(3172.962 4279.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_04_Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55980",
    "data-name": "Path 55980",
    d: "M967.484,389.593a210.844,210.844,0,0,1-2.456,34.656,80.718,80.718,0,0,1-9.094,26.3A60.351,60.351,0,0,1,934.3,472.917a58.764,58.764,0,0,1-62.988-2.7Q856.5,459.645,849,440.96a108.511,108.511,0,0,1-5.59-22.554,187.542,187.542,0,0,1-1.783-26.732,257.111,257.111,0,0,1,1.965-33.431,110.236,110.236,0,0,1,6.147-25.562q7.249-17.7,21.08-26.975t33-9.277a61.523,61.523,0,0,1,22.984,4.117,52.472,52.472,0,0,1,18.128,12.046,68.921,68.921,0,0,1,13.211,19.6Q967.48,352.468,967.484,389.593Zm-33.679-2.461q0-22.491-2.7-36.813t-9.094-21.632q-6.393-7.312-17.7-7.312-16.224,0-22.554,16.346t-6.33,50.389q0,23.108,2.7,37.856t9.094,22.306q6.385,7.558,17.328,7.56,11.3,0,17.7-7.864t8.973-22.493Q933.806,410.858,933.806,387.132Z",
    transform: "translate(-693.245 -296.43)",
    fill: "#978cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55981",
    "data-name": "Path 55981",
    d: "M1185.431,575.855V552.993h-61.7q-11.677,0-17.515-5.286t-5.838-14.381a13.917,13.917,0,0,1,.861-4.734,24.663,24.663,0,0,1,2.583-5.039q1.719-2.639,3.565-5.1t4.547-6.026l65.14-87.137a99.059,99.059,0,0,1,10.507-12.477,13.918,13.918,0,0,1,9.895-3.874q18.68,0,18.68,21.384v95.132h5.286q9.46,0,15.176,2.583t5.717,11.307q0,7.13-4.669,10.386t-14.012,3.256h-7.494v22.862q0,9.467-4.178,14.072a15.656,15.656,0,0,1-22.306-.122Q1185.426,585.072,1185.431,575.855Zm-52.85-50.394h52.85V454.052Z",
    transform: "translate(-830.945 -366.277)",
    fill: "#978cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8730",
    "data-name": "Group 8730",
    transform: "translate(0 57.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55982",
    "data-name": "Path 55982",
    d: "M609.505,607.7V584.833H547.8q-11.677,0-17.515-5.286t-5.839-14.381a13.913,13.913,0,0,1,.861-4.734,24.21,24.21,0,0,1,2.582-5.039q1.719-2.638,3.565-5.1t4.547-6.025l65.14-87.137a99.443,99.443,0,0,1,10.507-12.477,13.925,13.925,0,0,1,9.894-3.874q18.681,0,18.68,21.384V557.3h5.286q9.467,0,15.181,2.582t5.717,11.307q0,7.13-4.669,10.386t-14.011,3.256h-7.495v22.862q0,9.467-4.178,14.072a15.661,15.661,0,0,1-22.311-.122Q609.5,616.919,609.505,607.7ZM556.655,557.3h52.85V485.892Z",
    transform: "translate(-524.45 -440.78)",
    fill: "#978cff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nature",
    transform: "translate(236.755 213.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Plant_6_",
    d: "M1046.036,795.72a.8.8,0,0,1,.37.1,1.58,1.58,0,0,1,.627,1.127c.847,3.976.823,3,.4,8.22.889-3.256.538-2.685,2.2-5.628a3.938,3.938,0,0,1,1.245-1.5c3.63-2.222.117,7.626-.5,8.758-2.278,4.192-6.709,5.23-11.008,3.686-3.771-1.357-7.373-4.29-8.725-8.131-.122-.346-.21-.781.047-1.043a.968.968,0,0,1,.711-.206,9.831,9.831,0,0,1,6.152,2.62c1.74,1.464,3.181,3.256,4.818,4.833,1.16,1.118,3.724,1.053,5.324,1.249,2.723.327,3.8-.725,6.161-2.119a3.333,3.333,0,0,1,1.675-.575,1.351,1.351,0,0,1,1.343.968,1.739,1.739,0,0,1-.206,1.029c-1.937,4.089-7.209,3.541-9.534.276-2.218-3.111-3.645-8.294-2.583-12.028C1044.773,796.6,1045.367,795.706,1046.036,795.72Z",
    transform: "translate(-1030.525 -785.941)",
    fill: "#fdc510"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Plant_3_",
    d: "M1290.09,881c3.3-3.4,6.016-6.835,10.068-9.431,1.366-.875,2.961-1.684,4.529-1.273a1.088,1.088,0,0,1,.744.505,1.306,1.306,0,0,1,.028.814c-3.49,17.338-25.263,9.937-25.52-5.6a4.866,4.866,0,0,1,.58-2.765c.954-1.441,3.12-1.53,4.542-.561a7.544,7.544,0,0,1,2.676,4.379c1.226,4.491.632,9.254.023,13.852a30.1,30.1,0,0,1,6.929-16.5c.585-.683,1.53-1.385,2.26-.856a1.833,1.833,0,0,1,.589,1.142,13.163,13.163,0,0,1-1.656,9.08A34.831,34.831,0,0,1,1290.09,881Z",
    transform: "translate(-1134.416 -862.053)",
    fill: "#f44e4e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_13_Walking_the_dog",
    "data-name": "13 Walking the dog",
    transform: "translate(2978.64 4296.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8740",
    "data-name": "Group 8740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nature-2",
    "data-name": "Nature",
    transform: "translate(0 209.928)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ground",
    cx: 176.391,
    cy: 5.815,
    rx: 176.391,
    ry: 5.815,
    transform: "translate(49.602 18.139)",
    fill: "#e3e5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Plant_1_",
    d: "M521.077,924.034a8.374,8.374,0,0,1-2.08-4.082,1.448,1.448,0,0,1,.163-1.079,1.354,1.354,0,0,1,.835-.449c2.243-.479,4.347,1.164,5.966,2.785a57.074,57.074,0,0,1,7.6,9.454,14.879,14.879,0,0,1-1.688-8.351.372.372,0,0,1,.105-.256.341.341,0,0,1,.277-.039c.69.133,1.124.8,1.456,1.423a31.661,31.661,0,0,1,2.508,6.295c-.371-1.354.729-2.984,1.73-3.79,1.791-1.441,1.408.57,1.019,1.752-.38,1.158-2.912,5.695-4.718,4.682-.332-.187-.41-1.2-.684-1.522a3.487,3.487,0,0,0-1.809-.962,31.334,31.334,0,0,1-5.426-1.688A17.275,17.275,0,0,1,521.077,924.034Z",
    transform: "translate(-394.144 -918.339)",
    fill: "#a7adff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Plant_2_",
    d: "M771.575,959.925a29.1,29.1,0,0,1,.989-6.774,3.1,3.1,0,0,1,1.354-1.938.532.532,0,0,1,.44-.051.58.58,0,0,1,.259.3c3.964,7.6-6.678,11.872-11.534,6.156a2.276,2.276,0,0,1-.624-1.221,1.717,1.717,0,0,1,1.577-1.679,3.579,3.579,0,0,1,2.373.769,16.4,16.4,0,0,1,4.251,5.164,14.41,14.41,0,0,1-2.385-8.4c.015-.443.166-1.01.606-1.049a.873.873,0,0,1,.576.235,6.189,6.189,0,0,1,2.143,3.925A17.528,17.528,0,0,1,771.575,959.925Z",
    transform: "translate(-569.316 -941.246)",
    fill: "#f44e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Plant_3_2",
    "data-name": "Plant_3_",
    d: "M1472.555,949.76a.652.652,0,0,1,.3.081,1.246,1.246,0,0,1,.5.9c.678,3.183.66,2.4.323,6.578a11.793,11.793,0,0,1,1.76-4.5,3.153,3.153,0,0,1,.995-1.2c2.906-1.779.094,6.1-.4,7.009-1.821,3.355-5.369,4.184-8.809,2.948a11.456,11.456,0,0,1-6.982-6.509c-.1-.277-.169-.624.039-.835a.775.775,0,0,1,.567-.166,7.865,7.865,0,0,1,4.926,2.1c1.392,1.176,2.547,2.6,3.859,3.868.928.9,2.979.844,4.26,1,2.18.262,3.039-.582,4.929-1.694a2.639,2.639,0,0,1,1.341-.458,1.083,1.083,0,0,1,1.076.775,1.368,1.368,0,0,1-.166.823c-1.55,3.271-5.77,2.834-7.63.22-1.775-2.493-2.918-6.638-2.068-9.629C1471.542,950.465,1472.015,949.751,1472.555,949.76Z",
    transform: "translate(-1072.312 -940.288)",
    fill: "#f44e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Plant_4_",
    d: "M86.084,957.22a.72.72,0,0,1,.326.091,1.39,1.39,0,0,1,.552.995c.748,3.512.73,2.65.359,7.256.787-2.876.473-2.372,1.941-4.968a3.5,3.5,0,0,1,1.1-1.326c3.2-1.963.1,6.732-.44,7.733-2.011,3.7-5.924,4.615-9.719,3.253-3.328-1.2-6.512-3.789-7.7-7.181-.109-.308-.184-.69.042-.919a.872.872,0,0,1,.627-.184,8.67,8.67,0,0,1,5.432,2.315c1.537,1.3,2.81,2.873,4.257,4.269,1.025.989,3.286.931,4.7,1.1,2.4.289,3.352-.642,5.438-1.869a2.936,2.936,0,0,1,1.48-.507,1.194,1.194,0,0,1,1.185.856,1.488,1.488,0,0,1-.184.907c-1.709,3.612-6.367,3.126-8.42.244-1.96-2.749-3.22-7.323-2.282-10.621C84.966,958,85.491,957.208,86.084,957.22Z",
    transform: "translate(-72.393 -945.498)",
    fill: "#f44e4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Characters",
    transform: "translate(9.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(108.937 112.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55950",
    "data-name": "Path 55950",
    d: "M1088.924,652.056c-11.564-1.715-21.006-3.4-29.712-5.312-12.321-2.7-24.829-8.194-39.36-17.283-13.12-8.209-23.7-17.669-31.446-28.118-2.644-3.563-5.55-7.03-8.363-10.383-1.149-1.369-2.3-2.737-3.431-4.115a19.032,19.032,0,0,1-3.856,3.521c-2.05,1.411-3.931,1.935-5.589,1.555a4.532,4.532,0,0,1-3.087-2.728,4.472,4.472,0,0,1,.193-4.058c1.628-2.665,5.125-3.153,8.447-3-.754-1.185-1-2.1-.585-2.758a1.844,1.844,0,0,1,1.589-.862,5.734,5.734,0,0,1,3.883,2.2c1.432,2.071.612,3.934-.332,5.267,1.182,1.438,2.379,2.864,3.575,4.29,2.822,3.364,5.743,6.843,8.4,10.434,7.669,10.343,18.151,19.713,31.16,27.849,14.425,9.023,26.825,14.473,39.025,17.147,8.682,1.9,18.1,3.588,29.64,5.3ZM971.732,583.177c-2.505,0-5.321.485-6.56,2.514a3.415,3.415,0,0,0-.121,3.093,3.48,3.48,0,0,0,2.345,2.107c1.354.31,2.957-.16,4.754-1.4a17.991,17.991,0,0,0,3.75-3.455c-.021-.021-.039-.042-.06-.066-.922-1.007-1.715-1.914-2.342-2.725C972.95,583.2,972.35,583.177,971.732,583.177Zm3.259.226c.428.513.94,1.1,1.556,1.776.986-1.483,1.031-2.632.187-3.853a4.732,4.732,0,0,0-2.972-1.743h-.024a.8.8,0,0,0-.718.374c-.13.2-.078.76,1.052,2.282.633.06,1.248.136,1.83.217l-.148,1.049C975.542,583.476,975.286,583.44,974.991,583.4Z",
    transform: "translate(-963.688 -578.52)",
    fill: "#4b369d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dog",
    transform: "translate(159.035 157.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8729",
    "data-name": "Group 8729",
    transform: "translate(13.261 24.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55951",
    "data-name": "Path 55951",
    d: "M1174.364,840.038c1.212-3.675,3.4-7.482,7.1-8.607,4.025-1.224,8.14,1.133,12.074,2.632a39.225,39.225,0,0,0,9.846,2.216c-.5.084-1,.166-1.5.232-9.876,1.851-16.119-7.832-28.021,5.173C1174.02,841.133,1174.186,840.581,1174.364,840.038Z",
    transform: "translate(-1173.86 -824.945)",
    fill: "#ffeca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55952",
    "data-name": "Path 55952",
    d: "M1222.329,837.223a16.875,16.875,0,0,0-9,2.65c9.207-.567,17.97,1.3,27.424,5.5a43.255,43.255,0,0,0,10.527,2.764c3.979.6,10.361,1.709,14.175.422a32.537,32.537,0,0,0,6.542-3,12.071,12.071,0,0,0,1.2.476c2.43.79,5.062.814,7.476,1.646,2.493.856,4.781,2.568,7.416,2.565.929,0,2.125-.708,1.737-1.549a1.61,1.61,0,0,0-.708-.633c-3.081-1.821-5.282-4.043-7.944-6.331.476.175,1.016.347,1.637.513,2.71.727,5.336,1.718,8.082,2.3a5.48,5.48,0,0,0,2.3.157,5.56,5.56,0,0,0,2.725-1.993,4.029,4.029,0,0,0,.9-1.315,1.351,1.351,0,0,0-.317-1.471c-.705-.576-1.718.018-2.523.443-2.119,1.118-5.978-.721-8.215-1.58-1.9-.73-3.31-2.819-4.588-4.175a63.5,63.5,0,0,0,3.021-7.817,4.986,4.986,0,0,1,3.554-2.409c1.531-.111,3.042.323,4.546-.135.926-.284,2.379-1.058,2.363-2.2-.006-.516-.582-.986-.931-1.284a16.425,16.425,0,0,0-3.367-2.056c-.666-.332-1.239-.69-1.317-1.5-.06-.642-.172-1.248.645-.184a3.93,3.93,0,0,0,2.553,1.637c1.043.47,1.833,1.673,3.033,1.655,1.345-.021,2.092-1.191,3.165-1.917a1.4,1.4,0,0,0,.684-.811c.109-.576-.455-1.031-.953-1.326-2.032-1.206-4.679-1.947-6.475-3.485a6.385,6.385,0,0,1-.452-.455c-.636,1.182-2.291.823-1.52,2-4.19,0-6.741-4.257-10.931-3.545-.7,0-.624,2.1-.624,2.819,1.4,1.423,4.591,2.981,3.892,4.4,0,1.128-.977,1.459-2.2,1.522-1.975-1.378-6.159-4.4-8.459-4.727,0,2.849.645,8.067-2.2,8.782-4.983,1.423-7.712,3.678-12.695,1.544.711,1.423-.832,3.678.594,3.678,6.608,2.086,14.446,5.249,19.433,9.219.012.2.621,1.152.621,1.342a5.859,5.859,0,0,1-5.369,4.727c-3.494-4.362-8.112-8.553-11.718-6.15C1247.248,843.629,1234.433,837.934,1222.329,837.223Zm54.306.883c.244.2.482.4.724.6C1277.081,838.48,1276.837,838.281,1276.635,838.106Z",
    transform: "translate(-1201.432 -810.704)",
    fill: "#ffeca7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55953",
    "data-name": "Path 55953",
    d: "M1147.667,883.122c.154.066.024-.232-.145-.235-3.578-.048-7.051,1.1-10.443,2.234-1.387.464-2.888,1.016-3.642,2.27a.66.66,0,0,0,.284,1.043,5.442,5.442,0,0,0,3.207.5q5.594-.271,11.185-.546",
    transform: "translate(-1132.256 -836.642)",
    fill: "#f9ae10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55954",
    "data-name": "Path 55954",
    d: "M1373.223,731.335h0a.926.926,0,0,0,.922-.922h0a.926.926,0,0,0-.922-.923h0a.927.927,0,0,0-.923.923h0A.925.925,0,0,0,1373.223,731.335Z",
    transform: "translate(-1299.216 -729.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55955",
    "data-name": "Path 55955",
    d: "M1372.566,735.65a1.213,1.213,0,0,1,1.209,1.209h-2.415A1.21,1.21,0,0,1,1372.566,735.65Z",
    transform: "translate(-1298.56 -733.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55956",
    "data-name": "Path 55956",
    d: "M1131.84,821.857c2.8-1.724,5.7-3.479,7.639-6.138,2.05-2.81,2.391-6.4,3.877-9.472,1.658-3.428,5.227-5.682,8.866-6.5,5.571-1.245,10.925,1.535,16.439,1.782q5.142.231,10.286.094c3.334-.084,6.681.1,9.945-.748a35.164,35.164,0,0,0,12.258-5.435c3.979-2.963,5.891-7.681,9.737-10.672,2.581-2,6.168-3.868,9.505-3.913,3.467-.048,6.943,2.011,9.1,4.612,1.516,1.824,2.038,4.534,3.7,6.258-.648,1.182-1.6,2.1-.817,3.283-.473-.69-2.5-.736-3.283-1.064-2.285-.962-4.2-2.731-6.638-3.322a2.044,2.044,0,0,0-1.848.235,1.593,1.593,0,0,0-.166,1.923,10.168,10.168,0,0,0,2.27,2.11c.841.766,1.5,2.05.877,3a2.23,2.23,0,0,1-2.783.467,25.463,25.463,0,0,1-2.529-1.755c-1.091-.678-2.831-.853-3.355.624a4.444,4.444,0,0,0-.084,1.954c.7,6.484-8.589,6.81-13.02,6.117-.808-.127-3.069-1-3.093.3-.012.693,1.272,1.586,1.785,1.9a14.886,14.886,0,0,0,3.018,1.272c3.368,1.185,19.972,7.208,14.564,12.99a4.966,4.966,0,0,1-2.074,1.251,4.034,4.034,0,0,1-1.718.241c-2.918-.332-4.646-4.332-6.991-5.824-3.34-2.122-5.773-.039-9.035.913-7.443,2.171-15.233.883-22.715-.371a108.688,108.688,0,0,0-11.329-1.5c-2.56-.157-4.95.784-7.317,1.625a46.264,46.264,0,0,1-8.028,1.643,66.189,66.189,0,0,0-7.7,1.83c-2.689.8-5.785,3.25-8.5,3.97-.844.223-1.881.371-2.472-.271C1129.22,824.209,1130.6,822.62,1131.84,821.857Z",
    transform: "translate(-1129.872 -765.372)",
    fill: "#fdc510"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55957",
    "data-name": "Path 55957",
    d: "M1407.08,759.8a19.575,19.575,0,0,0,.941-3.334,1.081,1.081,0,0,1,.151-.476c.283-.389.959-.166,1.179.262s1.393,1.742,1.426,2.225c.148,2.131.811,2.849.781,5a6.491,6.491,0,0,1-2.945,5.342,1.02,1.02,0,0,1-.482.184.964.964,0,0,1-.627-.3c-1.628-1.423-1.806-3.922-1.32-6.029Z",
    transform: "translate(-1322.718 -747.863)",
    fill: "#f9ae10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55958",
    "data-name": "Path 55958",
    d: "M1452.616,802.4c.307.03.687.208.642.512-.036.235-.307.344-.537.413a8.393,8.393,0,0,0-2.086.992c-1.239.817-1.676.166-.708-.862A3.342,3.342,0,0,1,1452.616,802.4Z",
    transform: "translate(-1353.072 -780.41)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55959",
    "data-name": "Path 55959",
    d: "M1414.343,760.4a23.044,23.044,0,0,0,1.116-3.955,1.256,1.256,0,0,1,.178-.564c.775-1.067,1.911.971,2.189,1.553a15.353,15.353,0,0,1,.953,2.81c.226.886.536,1.76.7,2.659.579,3.168-.446,6.683-3.449,8.239a1.411,1.411,0,0,1-.392.151,5.067,5.067,0,0,1-2.089-.4,2.27,2.27,0,0,1-1.079-.766c-1.182-1.655.286-4.634.808-6.313C1413.279,763.817,1414.343,760.4,1414.343,760.4Z",
    transform: "translate(-1326.963 -747.715)",
    fill: "#f9dc2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55960",
    "data-name": "Path 55960",
    d: "M1418.6,766.74a.943.943,0,0,0-.163.145,5.191,5.191,0,0,0-.651,1.131c-.482.88-.934,1.773-1.345,2.68-.883,1.96-1.893,4.193-.476,6.162a.508.508,0,0,0,.211.2.7.7,0,0,0,.4.009,7.262,7.262,0,0,0,2.9-.868,2.652,2.652,0,0,0,.941-1.553c.66-2.49-.2-5.08-1.118-7.507-.084-.22-.241-.485-.506-.467A.47.47,0,0,0,1418.6,766.74Z",
    transform: "translate(-1329.224 -755.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55961",
    "data-name": "Path 55961",
    d: "M1446.062,807.385a19.565,19.565,0,0,1-2.472.452s.184.057,1.477.431,1.54.947,2.689.778a3.423,3.423,0,0,0,1.652-.6s.814-2.734-.341-2.165-2.7,1.112-2.7,1.112Z",
    transform: "translate(-1349.015 -783.075)",
    fill: "#f9ae10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55962",
    "data-name": "Path 55962",
    d: "M1459.423,808.3h0a1,1,0,0,1-.38,1.236,1.028,1.028,0,0,1-.512.112,1.2,1.2,0,0,1-.995-.555,1,1,0,0,1,.054-1.118.847.847,0,0,1,1.067-.205",
    transform: "translate(-1358.655 -784.094)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55963",
    "data-name": "Path 55963",
    d: "M1487.612,910.325s-.814-.986-.992,0-.47,1.423,0,1.281S1487.612,910.325,1487.612,910.325Z",
    transform: "translate(-1378.895 -855.503)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55964",
    "data-name": "Path 55964",
    d: "M1483.788,917.368c.009.036.072,0,.06-.033s-.054-.045-.09-.051a.968.968,0,0,0-1.025,1.311c.193.075.368-.136.489-.3a3.026,3.026,0,0,1,.931-.871",
    transform: "translate(-1376.313 -860.665)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55965",
    "data-name": "Path 55965",
    d: "M1477.908,922.4a1.011,1.011,0,0,0-1.218.265,1.61,1.61,0,0,0,1.469-.187",
    transform: "translate(-1372.136 -864.17)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55966",
    "data-name": "Path 55966",
    d: "M1455.24,939.193a.862.862,0,0,0-.455-.678c-.265-.1-.633.142-.546.41a.479.479,0,0,0,.3.265,1.107,1.107,0,0,0,.67.045",
    transform: "translate(-1356.444 -875.484)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55967",
    "data-name": "Path 55967",
    d: "M1459.429,940.318a.276.276,0,0,0-.172-.365.809.809,0,0,0-.455.012c-.172.039-.392.163-.323.326.036.087.139.117.232.136a2,2,0,0,0,.823-.027",
    transform: "translate(-1359.406 -876.486)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55968",
    "data-name": "Path 55968",
    d: "M1134.228,916.86s.853.923,0,1.04-.938-.313-.938-.313Z",
    transform: "translate(-1132.259 -860.374)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55969",
    "data-name": "Path 55969",
    d: "M1130.32,923.327s1.278-.148,1.157.386-.958,1.076-.958,1.076Z",
    transform: "translate(-1130.185 -864.878)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55970",
    "data-name": "Path 55970",
    d: "M1138.061,923.256c.178-.069,1.067.048.416.4s-.917.594-.844.06S1138.061,923.256,1138.061,923.256Z",
    transform: "translate(-1135.285 -864.829)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55971",
    "data-name": "Path 55971",
    d: "M1141.718,893.95s1.366.3.473.534-.775.3-1.128,0S1141.718,893.95,1141.718,893.95Z",
    transform: "translate(-1137.637 -844.371)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55972",
    "data-name": "Path 55972",
    d: "M1134.645,894.65s.883.307.3.521-1.167.437-1.167.437Z",
    transform: "translate(-1132.602 -844.86)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55973",
    "data-name": "Path 55973",
    d: "M1135.47,899.753s.35-.473,1.194,0,1.106.889.546.838-.609-.482-1.142-.422A.5.5,0,0,1,1135.47,899.753Z",
    transform: "translate(-1133.782 -848.277)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55974",
    "data-name": "Path 55974",
    d: "M1488.187,827.836a.711.711,0,0,1,.105-.283c.208-.29.657-.2.983-.051a11.313,11.313,0,0,1,1.691.913c1.112.73-.543,2.3-1.465,2.27C1488.278,830.646,1488,828.752,1488.187,827.836Z",
    transform: "translate(-1380.131 -797.858)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55975",
    "data-name": "Path 55975",
    d: "M1376.786,814.22c-.567.705,2.861,6.117,3.385,6.855a13.134,13.134,0,0,0,4.965,4.124c3.943,1.969,8.429,2.5,12.716,3.271l-1.052,2.195c-6.527-1.625-13.452-2.24-17.726-7.823-.579-.757-4.447-5.933-3.856-6.665Z",
    transform: "translate(-1301.212 -788.677)",
    fill: "#f44e4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Man",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(69.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Neck",
    d: "M881.916,329.836,879.224,342.4,868.7,344.65s7.347-7.778,7.57-15.709S881.916,329.836,881.916,329.836Z",
    transform: "translate(-861.161 -289.386)",
    fill: "#d4a79a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M901.114,241.126s1.706,3.2-1.794,11.646-6.5,14.642-9.059,13.693a19.857,19.857,0,0,1-12.267-12.285c-2.246-5.933,6.032-18.221,6.032-18.221l6.331-2.219Z",
    transform: "translate(-867.384 -225.195)",
    fill: "#eac2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M855.459,227.113c-.256.036.956,10.63.983,11.582-1.794-1.839-4.211-3.615-5.671-5.731-2.228-3.235-3.708-6.216-6.69-8.842-1.516-1.336,1.911-2.825,1.788-2.93-.817-.69-1.423-1.589-.093-2.225.576-.274,1.281-.413,1.613-.956a1.423,1.423,0,0,0-.075-1.441c-.853-1.4-3.8-2.4-2.52-4.6.744-1.275,2.27-1.293,2.8-2.846a6.968,6.968,0,0,1,.79-1.987c1.884-2.55,5.975.675,8.393.332,1.622-.229,2.662-1.8,4.308-1.993a10.569,10.569,0,0,1,5.695.76c1.95,1.076,2.433,4.356,4.254,5.119a2.583,2.583,0,0,0,1,.136c3.268.021,6.325-.407,9.122,1.574,4.414,3.126,2.734,15.758-3.624,12.806-.729-.338-1.369-.841-2.068-1.236-3.377-1.9-7.078,2.134-9.725-3.2-.473-.953-7.111-.7-6.952,2A3.379,3.379,0,0,1,855.459,227.113Z",
    transform: "translate(-843.693 -205.394)",
    fill: "#4b369d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ear",
    d: "M881.3,273.857s-2.21-3.47-2.653,1.221,1.839,6.035,1.839,6.035Z",
    transform: "translate(-868.07 -252.355)",
    fill: "#eac2ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leg_4_",
    transform: "translate(13.823 97.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    d: "M698.852,814.487,685.3,824.11l-3.684-4.2,14.733-9.2S698.692,812.715,698.852,814.487Z",
    transform: "translate(-675.281 -726.041)",
    fill: "#d4a79a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M676.6,857.66c-.323.193-1.941-.826-2.195-.956-2.617-1.357-6.708-3.31-8.134-6.011-1.39-2.632-1.438-5.9-2.412-8.688a26.162,26.162,0,0,0-3.132-5.381c-1.242-1.917,6.669-8.037,8.109-5.586,1.167,1.984-1.251,4.447,3.367,6.439,3.958,1.706-1.348,5.821,1.326,11.407C675.891,853.816,680.124,855.547,676.6,857.66Z",
    transform: "translate(-660.593 -739.842)",
    fill: "#f3aa02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg_5_",
    d: "M739.562,571.33c-3.286,11.715-1.375,11.9-9.466,21.042-3.946,4.456-28.187,13.5-32.254,17.85-5.8,6.21-.95,12.481,3.355,14.3,2.816,1.191,4.037,7.314,8.317,2.758.422-.449,7.974-7.335,10.186-11.5,2.532-4.769,20.91-14.428,25.911-19.017,11.908-10.916,5.891-16.162,13.177-30.454,2.773-5.441,2.159-11.236,2.982-17.494.5-3.832-5.342-21.757-13.472-18.588-5.059,1.974-3.126,12.236-2.912,16.285.151,2.8.552,5.888-.142,8.595C743.818,560.661,741.114,565.792,739.562,571.33Z",
    transform: "translate(-684.75 -529.851)",
    fill: "#4b369d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leg",
    transform: "translate(69.327 96.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin_1_",
    d: "M909.036,855.685l.006,17.12-5.722.591,1.055-17.862S907.453,854.76,909.036,855.685Z",
    transform: "translate(-885.65 -755.721)",
    fill: "#eac2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shoe_1_",
    d: "M919.88,914.578a52.818,52.818,0,0,1-12.071-.627c-7.778-1.112-16.382-2.7-17.684-4.181s-.181-11.35,2.37-10.793,2.731,4.471,7.953,2.165c4.474-1.978,6.382,4.022,12.782,6.913S922.222,912.115,919.88,914.578Z",
    transform: "translate(-876.052 -786.264)",
    fill: "#fdc510"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg_1_",
    d: "M878.547,634.277c-.262-.612-.03-3.66,0-4.425.308-7.82-.708-11.206.148-17.024,4.224-28.7,6.569-34.494-.223-46.369-6.7-11.706-11.094-16.81-12.222-30.87-.392-4.881,9.276-11.187,1.9-9.792a28.78,28.78,0,0,1-10.425-.078c-1.833-.32.036-.916-1.833-.32-6.37,2.032-11.109,13.436-11.187,17.829-.178,9.846,22.028,25.326,21.543,34.168-1.148,21.045-2.77,16.578-4.26,29.022-.729,6.1-1.577,6.888-2.391,12.975-.473,3.548-1.191,7.32-4.766,11.4-3.419,3.907,17.979,7.142,22.049,7.042C879.943,637.765,879.439,636.36,878.547,634.277Z",
    transform: "translate(-844.706 -525.145)",
    fill: "#5a54ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hand",
    d: "M954.591,544.7c-.307-2.906-.2-2.207-1.688-2.041s-8.58-2.96-11.016-4.23c-.926-.482-4.609-4.151-8.878-8.583a4.693,4.693,0,0,1-3.817,1.5c-.558-.021-1.109-.057-1.652-.112a102.177,102.177,0,0,0,8.791,7.736c2.816,1.61,1.757,1.956,3.057,4.465s2.177,3.373,4.233,3.72a15.6,15.6,0,0,0,5.634-.289c1.094-.28,1.321,3.449,1.836,4.6s1.45-1.73,1.45-1.73-.072,2.276,1.01,2.8S954.9,547.609,954.591,544.7Z",
    transform: "translate(-833.242 -432.038)",
    fill: "#eac2ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(60.029 45.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55976",
    "data-name": "Path 55976",
    d: "M848.07,385.182c-1.845-7.5.16-20.108-5.125-25.667a6.063,6.063,0,0,0-1.833-1.456c-6.641-2.991-10.645,2.46-13.5,7.187s-2.794,9.849-4.19,15.155c-1.586,6.029,1.691,10.138,1.577,16.364-.069,3.789-1.628,8.694-1.839,12.49-.148,2.65-8.667,11.721-9.273,14.3-.4,1.718,4.555-.286,5.209,1.462.519,1.384,2.9.862,4.067.9a27.526,27.526,0,0,0,12.978-3.181c3.675-1.815,7.557-1.746,11.8-2.1,2.1-.175,4.833-1.987,3.88-5.812-2.255-9.062-1.6-17.006-2.532-23.406C848.983,389.352,848.582,387.259,848.07,385.182Z",
    transform: "translate(-813.863 -357.205)",
    fill: "#d7384e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55977",
    "data-name": "Path 55977",
    d: "M888.424,385.255s-3.756,8.185-1.966,16.122,1.577,17.111,6.533,22.932,12.188,18.311,13.424,17.8,2.547-3.211,6.035-4.86,2.053-2.707-5.08-8.176-11.462-10.937-12.3-19.755S898.656,377.775,888.424,385.255Z",
    transform: "translate(-864.236 -375.76)",
    fill: "#f44e4e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Scraf",
    transform: "translate(0 24.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55978",
    "data-name": "Path 55978",
    d: "M696.769,294.188s-22.357-19.378-31.527.449-6.433,21.766-23.78,16.484c-24.7-7.522-15.351,2.731-25.052,5.634-5.758,1.721,5.221,6.693,5.221,6.693s-.247,1.947,5.188,2.963,6.828,1.182,7.271,2.6,2.014.38,1.242-1.791-1.233-8.441,1.748-7.938,9.3,8.758,20.241,5.643,14.711-23.753,21.974-21.217,1.866,8.055,15.209,5.481,2.264-15,2.264-15Z",
    transform: "translate(-614.74 -285.707)",
    fill: "#f9ae10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55979",
    "data-name": "Path 55979",
    d: "M879.8,324.3s2.656,7.488,7.187,7.5,4.582-1.26,3.672,2.8,1.351,4.564,0,7.1-4.775.069-6.264-1.993a11.319,11.319,0,0,0-6.123-4.13C875.82,334.848,874.6,332.427,879.8,324.3Z",
    transform: "translate(-797.355 -312.666)",
    fill: "#fdc510"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.05057ed4c20ff86b8daac9af2efb74ea.svg";
export { ForwardRef as ReactComponent };